<script>

import Popper from "vue3-popper";
import { useToast } from "vue-toastification";

//components
import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getContactsToSend, unlockCampaign, sendCampaignSMS, sendCampaignEmail } from '@/services/mailing/serviceCampaign';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'CampaignSend',
	mixins: [ MixinGeneralFunct ],
	components: {
		Popper
		,LoadingScreen
		,LoadingButton
	},
	props: {'campaignId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["campaignId","changeRecord"],
	data() {
	
		return {
			metaData: [],
			
			isLoading:true,
			isSending:false,
			
			//form
			contactsValid:[],
			contactsToSend:[],
			contactsSent:[],
			data:[],
			template:[],

			optionsCategories:[],
		
			//tabs
			tab1:'',
			tab2:'',
			tab3:'',
		}
	},
	
	mounted:function(){
		this.tab1 = `tab${this.getRandomInt(99999999999)}`;
		this.tab2 = `tab${this.getRandomInt(99999999999)}`;
		this.tab3 = `tab${this.getRandomInt(99999999999)}`;
	},
	
	methods: {
		// load data form
		loadDefaultValues:function(){

			this.isLoading=true
			
			getContactsToSend({campaignId:this.campaignId,optionsCategories:this.optionsCategories}).then(response => {
				if(!response.statusText){
					console.log(response)
					this.isLoading=false
					this.metaData = response.metaData;
					this.data = response.data;

					this.contactsValid = response.contactsValid;
					this.contactsToSend = response.contactsToSend;
					this.contactsSent = response.contactsSent;
			//		this.campaign = response.data.campaign;
					this.template = response.template;
					this.optionsCategories = response.optionsCategories;

				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
			
		
		},


		onSendCampaignEmail:function(){
			
		//	if(this.checkSave()){
				
				this.isSending=true
				sendCampaignEmail({campaignId:this.campaignId,optionsCategories:this.optionsCategories}).then(response => {
					if(!response.statusText){
						this.isSending=false
						if(response.resCode==1){
							this.toast.success(this.$t('msgCore.dataWasSaved'));
							this.$emit('changeRecord', '')
							this.data = [];
							this.modalObject.hide();
						}else if(response.resCode==0){
							this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
						}else if(response.resCode==2){
							this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
						}else if(response.resCode==3){
							this.toast.error(this.$t('msgCore.accessDenied'));
						}
					}else{
						this.isSending=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
				
		//	}
			
		},
				

		onSendCampaignSMS:function(){
			
		//	if(this.checkSave()){
				
				this.isSending=true
				sendCampaignSMS({campaignId:this.campaignId,optionsCategories:this.optionsCategories}).then(response => {
					if(!response.statusText){
						this.isSending=false
						if(response.resCode==1){
							this.toast.success(this.$t('msgCore.dataWasSaved'));
							this.$emit('changeRecord', '')
							this.data = [];
							this.modalObject.hide();
						}else if(response.resCode==0){
							this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
						}else if(response.resCode==2){
							this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
						}else if(response.resCode==3){
							this.toast.error(this.$t('msgCore.accessDenied'));
						}
					}else{
						this.isSending=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
				
		//	}
			
		},

		onClose:function(){
			if(this.campaignId!='null'){
				unlockCampaign(this.campaignId).then(response => {
					if(!response.statusText){
						this.isLoading=false
						if(response.resCode==1){
							this.$emit('changeRecord', '')
							this.modalObject.hide();
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.$emit('changeRecord', '')
				this.modalObject.hide();
			}
		},

	},
	
	watch: {
		campaignId() {
			this.loadDefaultValues();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>

		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-lg">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title">{{ $t('msgCustomMailing.Campaign') }} <b>{{ data.title }}</b> </h6>
					</div>
			
							<div v-if="metaData.modulAccess && auth.campaignsSend" class="modal-body">
								
								<div class="row">
									<div class="col-12">
										<div v-if="data.isCheckedOut && secData.userId != data.isCheckedOutId" class="angle">
											<span class="angle-inner" :class="{'angle-warning':data.isCheckedOut}"><i class="fa" :class="{'angle-warning':data.isCheckedOut, 'fa-exclamation-triangle':data.isCheckedOut}" aria-hidden="true"></i> {{$t('msgCore.Edited')}} </span >
											
											<Popper v-if="data.isCheckedOut" :content="data.isCheckedOutName+', '+data.isCheckedOutDate">
												<button class="personCircle v-center" v-bind:style="{background:data.isCheckedOutColor}">{{ data.isCheckedOutLetterName+''+data.isCheckedOutLetterSurname }}</button>
											</Popper>
											
										</div>
									</div>
								</div>

								
							
								<div class="row">
									
									<div class="col-md-12 col-12">
								
										<ul class="nav nav-tabs" role="tablist">
							
											<li class="nav-item" role="presentation">
												<a class="nav-link active" :id="`${tab1}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab1}`" role="tab" :aria-controls="tab1" aria-selected="true">{{ $t('msgCore.basicData') }}</a>
											</li>
											
											<li v-if="data.typeId==1" class="nav-item" role="presentation">
												<a class="nav-link" :id="`${tab2}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab2}`" role="tab" :aria-controls="tab2" aria-selected="false">Email náhľad</a>
											</li>

											<li v-if="data.typeId==2" class="nav-item">
												<a class="nav-link" :id="`${tab3}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab3}`" role="tab" :aria-controls="tab3" aria-selected="false">Text SMS</a>
											</li>
											
										</ul>

										<div class="tab-content" id="myTabContent">
								
											<div :id="`${tab1}`" class="tab-pane active" role="tabpanel" :aria-labelledby="`${tab1}-tab`">

												<div class="row">	
													<div class="col-12" >
														<label><b>Výber kategórie</b> </label>
														<div  v-for="(item) in optionsCategories" :key="item" class="togglebutton">
															<label>
															<input v-model='item.isSelected' type="checkbox" v-on:change="loadDefaultValues()">
															<span class="toggle"></span>
															{{item.title}}
															</label>
														</div>
													</div>
												</div>

												
												
												<div v-if="data.typeId==1" class="row">
																									
													<div class="col-12">
														<table class="table table-sm">
															<tr>	
																<td>Emaily vo fronte: {{contactsToSend}}</td>
																<td>Odoslané emaily: {{contactsSent}}</td>
																<td>Vhodné emaily k odoslaniu: {{contactsValid}}</td>
															</tr>
														</table>
													</div>
													
												</div>	

												<div v-if="data.typeId==2" class="row">
																									
													<div class="col-12">
														<table class="table table-sm">
															<tr>	
																<td>SMS vo fronte: {{contactsToSend}}</td>
																<td>Odoslané SMS: {{contactsSent}}</td>
																<td>Vhodné SMS k odoslaniu: {{contactsValid}}</td>
															</tr>
														</table>
													</div>
													
												</div>	

											</div>

											
											<div v-if="data.typeId==1" :id="`${tab2}`" class="tab-pane" role="tabpanel" :aria-labelledby="`${tab2}-tab`">
												<div class="row">
													<div class="col-12" v-html="template.logo"></div>
												</div>
												<div class="row">
													<div class="col-12">
														<table>
															<tr>
																<td v-html="data.full_text">

																</td>
															</tr>
														</table>
													</div>
												</div>
												<div class="row">
													<div class="col-12" v-html="template.pata"></div>
												</div>
											</div>


											<div v-if="data.typeId==2" :id="`${tab3}`" class="tab-pane" role="tabpanel" :aria-labelledby="`${tab3}-tab`">
											
												<div class="row">
													<div class="col-12">
														{{data.sms_text}}
													</div>
												</div>
												
											</div>
											
										</div>
										
									</div>
									
																		
																		
								</div>
								
							</div>
							
							<div v-else class="modal-body">
								<div class="row">
									<div class="col-12">
										<div class="alert alert-warning" role="alert">
											{{$t('msgCore.accessDenied')}}
										</div>
									</div>
								</div>
							</div>
							
							<div class="modal-footer">
							
								<div class="btn-group">
									<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
									
									<LoadingButton v-if="data.typeId==1" :isDisabled="(contactsValid==0 || !auth.campaignsSend || !metaData.modulAccess || isSending)" :isSending="isSending" @onClick="onSendCampaignEmail" :label="'msgCustomMailing.PlaceEmailsToFront'" color="warning"></LoadingButton>

									<LoadingButton v-if="data.typeId==2" :isDisabled="(contactsValid==0 || !auth.campaignsSend || !metaData.modulAccess || isSending)" :isSending="isSending" @onClick="onSendCampaignSMS" :label="'msgCustomMailing.PlaceSMSToFront'" color="warning"></LoadingButton>
								</div>	
								
							</div>
						
				
					
					
				
				</div>

			</div>
			
		</div>
		
	</div>
	
	

</template>


